import { useEffect, useRef, useState } from "react";

export const useMaxWidthApplied = (isVisible: boolean) => {
  const contentRef = useRef(null);
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const currentWidth = entry.contentRect.width;

        if (currentWidth > maxWidth) {
          setMaxWidth(currentWidth);
        }
      }
    });

    const content = contentRef.current;
    if (content) {
      observer.observe(content);
    }

    return () => {
      if (content) {
        observer.unobserve(content);
      }
    };
  }, [maxWidth, isVisible]);

  return {
    contentRef,
    maxWidth,
  };
};
